import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e277446"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["selected"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Selecionados", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("select", {
    class: "select-input",
    id: "selection",
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeOrder($event)))
  }, [
    _createElementVNode("option", {
      value: "0",
      selected: !_ctx.$route.query.filterBy
    }, "Todos", 8, _hoisted_1),
    _hoisted_2
  ], 32))
}